import { renderState } from '@/helpers/vuex';
import { createRegistrationItem, sendGA4sEvent } from '@/helpers/tracking/ga';
import { registerCodeEnum } from '@/constant/payment-info';
import store from '@/store/index';

export const processRegisterResponse = (res, context) => {
  const { code, description } = res.data;
  const { successCode, goVerifyOTP, verifyOTPLimitCode } = registerCodeEnum;

  const handleResponseByCode = {
    [successCode]: () => {
      context.emit('cancel');
      sendGA4sEvent('sign_up', createRegistrationItem('註冊完成', 'cart'));
      return context.emit('invoke-confirm-order');
    },
    [goVerifyOTP]: () => store.commit('DynamicComponents/setRegisterMethod', 'step2'),
    [verifyOTPLimitCode]: () => {
      // case : click 「下一步」鈕 at step2 Modal ; 只有在 step2 Modal 才會有此情況
      // step1: 在 step2_Modal 的輸入驗證碼下方 show error msg
      store.commit('RegisterSenaoMembership/setValidateErrorMsg', description);
      // step2: disable step2_Modal 的下一步鈕 (原因: 請 user 勿再試) 需等待秒數倒數完 user can click 重發驗證碼
      store.commit('RegisterSenaoMembership/setIsDisabledVerifyOTPBtn', true);
      // 紀錄該用戶驗證碼輸入錯誤次數已達上限，為了控制下一步鈕的 disable 狀態，等待倒數完後才會 enable
      store.commit('RegisterSenaoMembership/setIsVerifyOTPLimit', true);
    },
    default: () => {
      // case: 註冊失敗 or 驗證碼錯誤
      store.commit('RegisterSenaoMembership/setValidateErrorMsg', description);
    },
  };
  (handleResponseByCode[code] || handleResponseByCode.default)(context);
};

/**
 * format birthday Params for /register API
 * @returns {string}
 */
export const setFormatBirthdayForPOST = () => {
  const birthYear = renderState('OrderInfo', 'userPickBirthYear');
  const birthMonth = renderState('OrderInfo', 'userPickBirthMonth');
  const birthDate = renderState('OrderInfo', 'userPickBirthDate');
  return Number(birthYear) * 10000 + Number(birthMonth) * 100 + Number(birthDate);
};

/**
 * /register API Params
 * @param {Boolean} isFetchReVerifyOTP
 * @returns {object}
 */
const getOrderInfoParams = (isFetchReVerifyOTP) => {
  if (isFetchReVerifyOTP) {
    return { mobile: renderState('OrderInfo', 'mobilePhone') };
  }
  const defaultParams = {
    mobile: renderState('OrderInfo', 'mobilePhone'),
    name: renderState('OrderInfo', 'name'),
    email: renderState('OrderInfo', 'email'),
    gender: renderState('OrderInfo', 'userPickGender'),
    birthday: `${setFormatBirthdayForPOST()}`,
    ...(Object.keys(renderState('OrderInfo', 'marketingOptions')).length > 0 &&
      renderState('OrderInfo', 'marketingOptions')),
    ...(renderState('DynamicComponents', 'registerMethod') === 'step2' && {
      authCode: renderState('RegisterSenaoMembership', 'authCode'),
    }),
  };
  return defaultParams;
};

/**
 * create register API FormData
 * @param {Boolean} isFetchReVerifyOTP
 * @returns {FormData}
 */
export const createFormDataFromOrderInfo = (isFetchReVerifyOTP = false) =>
  Object.entries(getOrderInfoParams(isFetchReVerifyOTP)).reduce((data, [keyFor, value]) => {
    data.append(keyFor, value);
    return data;
  }, new FormData());
